var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSigninBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,6a7.2,7.2,0,0,1,6.93,7.43,7.2,7.2,0,0,1-6.93,7.43,7.19,7.19,0,0,1-6.93-7.43A7.19,7.19,0,0,1,18.5,6Zm0,26c-5.89,0-8.5-2.6-8.5-3.12a10.28,10.28,0,0,1,2.34-6.56,9,9,0,0,0,12.35,0A10.4,10.4,0,0,1,27,28.88C27,29.4,24.39,32,18.5,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,37A18.5,18.5,0,1,1,37,18.5,18.52,18.52,0,0,1,18.5,37Zm0-35A16.5,16.5,0,1,0,35,18.5,16.52,16.52,0,0,0,18.5,2Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSigninBlack);
export default __webpack_public_path__ + "static/media/icon_signin-black.cb8e74ab99dc433b9afed6d7046ba844.svg";
export { ForwardRef as ReactComponent };